import { lazy } from "react";
import DefaultLayout from "../../erp/layouts/DefaultLayout";
const MainLayout = lazy(() => import("../layouts/MainLayout"));


var indexRoutes = [
    { path: "/login", exact: true, name: "default", component: DefaultLayout },
    { path: "/", name: "Home", component: MainLayout, isPrivate: true }
];

export default indexRoutes;




// WEBPACK FOOTER //
// ./src/erp/routes/index.js